import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { useChannelListContext } from '../channel-list.context';
import { CHANNEL_LIST_COLUMN_LABEL_I18N_KEY } from '../channel-list/channel-list.config';

export const ChannelListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useChannelListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={CHANNEL_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
